export default "__VITE_ASSET__fa2903d1__"